import { SOCKETS_URL } from 'services/constants';
import { getActiveCompanyId } from 'utils/activeCompany';
import { getStoreState } from 'utils/authStateRegistry';
import { getActiveAuthToken } from 'utils/getActiveAuthHeaders';
import io from 'socket.io-client';

const getSocket = (namespaceIn, queryIn) => {
  let namespace = namespaceIn;
  const query = queryIn || {};
  let auth;
  if (!queryIn) {
    const authState = getStoreState()?.auth;
    // Impersonation is encoded in the scoped token, so no impersonate query param is needed.
    const token = getActiveAuthToken(authState);
    const companyId = getActiveCompanyId();
    auth = {
      token: token.hash,
    };
    if (!namespace && companyId) {
      namespace = companyId;
    }
  }
  const socket = io(`${SOCKETS_URL}/${namespace}`, {
    transports: ['websocket', 'polling'], // WebSocket first to avoid session issues
    path: '/', // Must match server's path config
    query,
    secure: SOCKETS_URL.startsWith('https'),
    auth,
    withCredentials: true, // Required for cross-origin cookies
    reconnection: true,
    reconnectionDelay: 10000,
    reconnectionDelayMax: 30000,
    reconnectionAttempts: Infinity,
  });
  return socket;
};

export default getSocket;
